import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import { ResourceAccessPage } from "@/features/console/pages/ResourceAccessPage";

export const Route = createFileRoute("/_authed/_modal/console/document-access/$documentId")({
  component: DocumentAccessRoute,
});

function DocumentAccessRoute(): React.ReactElement {
  const { documentId } = Route.useParams();
  return <ResourceAccessPage documentId={documentId} />;
}
